import React, { useMemo, useState } from "react";
import GridTable from "../../constant/GridTable";
import { exchangeType, parseDate } from "../../constant/enum";
import moment from "moment";
import { useDeleteLimitOrderMutation } from "../../../redux/limitOrderApi";
import { toast } from "react-toastify";


function PendingOrder({ pendingOrderHistory,TradeStatusPros }) {
  const [deleteLimitOrder] = useDeleteLimitOrderMutation();
  const [disable, setDisable] = useState(false)
  const colDefs = [
    {
      headerName: "Action",
      field: "action",
      cellRenderer: (params) => {
        return (
          <button
            className="btn btn-danger"
            onClick={() => {
              deleteFun(params.data.id);
            }}
            disabled={disable}
          >
            <i className="bi bi-trash"></i>
          </button>
        );
      },
    },
    {
      headerName: "Sr.No.",
      field: "id",
      valueGetter: "node.rowIndex + 1",
      sortable: true,
      filter: "agNumberColumnFilter",
    },
    {
      headerName: "Type",
      field: "trade_type",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Exchange",
      field: "exchange_type",
      sortable: true,
      cellRenderer: (params) => {
        return (
          <>
            {
              exchangeType.filter(
                (list) => list.value == params.data.exchange_type
              )[0]?.key
            }
          </>
        );
      },
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Symbol",
      field: "symbol",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Quantity",
      field: "quantity",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Open/Close Price",
      field: "open_price",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Stop Price",
      field: "stop_price",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Order Side",
      field: "order_side",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Order Type",
      field: "order_type",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Status",
      field: "trans_status",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Date",
      field: "createdAt",
      cellRenderer: (params) => {
        return <>{moment(params.value).format("lll")}</>;
      },
      sortable: true,
      filter: "agDateColumnFilter",
      filterParams: {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          const cellDate = parseDate(cellValue);
          if (!cellDate) {
            return -1;
          }
          if (cellDate.getTime() === filterLocalDateAtMidnight.getTime()) {
            return 0;
          }
          return cellDate < filterLocalDateAtMidnight ? -1 : 1;
        },
      },
    },
  ]
  const rowClassRules = useMemo(() => {
    return {
      "sick-days-warning": "data.order_side =='SELL'",
      "sick-days-breach": "data.order_side =='BUY'",
    };
  }, []);

  const deleteFun = (id) => {
    if(TradeStatusPros){
      toast.dismiss()
      toast.error("Previous trade is processing please wait 2-4 sec.")
      return
    }
    const sendData = { id };
    setDisable(true)
    deleteLimitOrder(sendData).then((res) => {
      if (res.data.status) {
        toast.dismiss();
        toast.success(res.data.message);
        setDisable(false)
      } else {
        toast.dismiss();
        toast.error(res.data.message);
        setDisable(false)
      }
    });
  };

  return (
    <div className=" ">
      <h4 className="trade_history">Pending History</h4>
      <div>
        <GridTable
          data={pendingOrderHistory}
          colDefs={colDefs}
          height="100vh"
          rowClassRules={rowClassRules}
        />
      </div>
    </div>
  );
}

export default PendingOrder;
